/**
 * Calendar widget sponsor config.
 *
 * Currently DISABLED — set to `null` while no partnership is active.
 * To enable a sponsor:
 *   1. Fill the object below with `name` (required) and `logo`
 *      (optional React node, ideally a small monochrome SVG).
 *   2. Rebuild — the widget picks it up automatically. No changes
 *      needed in ReleasePosterCard or AddToCalendar.
 *
 * Design constraints:
 *   - `name` is the ONLY field that survives into the calendar .ics
 *     (as plain text "Rappel proposé par {name}") — iCal RFC 5545
 *     forbids inline images, so the logo is site-only.
 *   - `logo`  is displayed only inside the popover on the site.
 *
 * Example (kept commented for a future turn-on):
 *
 *   export const CALENDAR_SPONSOR = {
 *     name: "Pathé+",
 *     logo: (
 *       <svg viewBox="0 0 88 24" className="h-4 w-auto text-neutral-900" fill="currentColor">
 *         <text x="0" y="18" fontFamily="Inter" fontSize="18" fontWeight="900">PATHÉ</text>
 *         <circle cx="76" cy="11" r="9" fill="#c8102e" />
 *         <text x="76" y="16" textAnchor="middle" fill="white" fontSize="14" fontWeight="900">+</text>
 *       </svg>
 *     ),
 *   };
 */
export const CALENDAR_SPONSOR = null;
